/**
 * @flow
 */

import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { format } from 'date-fns';
import { Select } from '../../../../components';
import { convertMinutesToDateTime } from '../../../../lib/date';

function TimeSelect({ value, options, settings, dispatch, ...rest }) {
    // If there is a value but no options yet, show the value as a text placeholder.
    // Salon settings may not be loaded yet (redux initial state is {});
    // date-fns format() throws on an undefined format string, so fall back
    // to the app's standard time format.
    let text = null;
    if (value && isEmpty(options)) {
        const timeFormat = (settings && settings.format) || 'HH:mm';
        text = format(convertMinutesToDateTime(value), timeFormat);
    }

    return <Select value={value} options={options} text={text} {...rest} />;
}

export default connect(({ salon }) => ({
    settings: salon.get('settings'),
}))(TimeSelect);
